import { AddBanners, AddNotification, AddQuicklinks, AddReviews, Banners, CreateServices, Dashboard, Notifications, ProfileEdit, Quicklinks, Reports, Reviews, Services } from "views/pages/app";
import { routes } from "../utils/routes";
import EmployeeListing from "views/pages/app/employees/listing";
import AddStore from "views/pages/app/stores/add";
import StoreListing from "views/pages/app/stores/listing";
import EmployeePage from "views/pages/app/employee-page";
import AddEditEmployee from "views/pages/app/employees/add-edit.tsx";
import AddEditCustomer from "views/pages/app/customers/add-edit.tsx";
import CustomerLsiting from "views/pages/app/customers/listing";
import DealLisiting from "views/pages/app/deals/listing";
import AddEditDeals from "views/pages/app/deals/add-edit.tsx";
import Excel from "views/pages/app/excel";
import PromocodeLisiting from "views/pages/app/promocodes";
import ViewEmployee from "views/pages/app/employees/add-edit.tsx/view";
import PromocodeValidate from "views/pages/app/promocode-validate";
import Blogs from "views/pages/app/blogs";
import AddBlogs from "views/pages/app/blogs/add";

const PrivateRoutes = [
  {
    path: `${routes.dashBoard}`,
    exact: true,
    name: "Dashboard",
    component: Dashboard,
  },
  {
    path: `${routes.profile}`,
    exact: true,
    name: "Change Password",
    component: ProfileEdit,
  },
  {
    path: `${routes.employees}`,
    exact: true,
    name: "Employee",
    component: EmployeeListing,
  },
  {
    path: `${routes.customers}`,
    exact: true,
    name: "Customer",
    component: CustomerLsiting,
  },
  {
    path: `${routes.deals}`,
    exact: true,
    name: "Deal",
    component: DealLisiting,
  },
  { path: `${routes.stores}/edit/:id`, exact: true, name: 'Stores Edit', component: AddStore },

  {
    path: `${routes.stores}/create`,
    exact: true,
    name: "New Stores",
    component: AddStore,
  },
  {
    path: `${routes.services}`,
    exact: true,
    name: "Services",
    component: Services,
  },
  {
    path: `${routes.services}/create`,
    exact: true,
    name: "Create Services",
    component: CreateServices,
  },
  {
    path: `${routes.stores}`,
    exact: true,
    name: "Stores",
    component: StoreListing,
  },
  {
    path: `${routes.promocode}`,
    exact: true,
    name: "Promocode",
    component: PromocodeLisiting,
  },
  {
    path: `${routes.employeePage}`,
    exact: true,
    name: "Employeepage",
    component: EmployeePage,
  },

  {
    path: `${routes.excel}`,
    exact: true,
    name: "Excel",
    component: Excel,
  },

  {
    path: routes.promocodeValidate,
    name: "Promocode Validate",
    component: PromocodeValidate,
  },

  {
    path: routes.blogs,
    name: "blogs",
    component: Blogs,
  },

  { path: `${routes.deals}/create`, exact: true, name: 'Add Customer', component: AddEditDeals },
  { path: `${routes.deals}/edit/:id`, exact: true, name: 'Edit Customer', component: AddEditDeals },

  { path: `${routes.customers}/create`, exact: true, name: 'Add Customer', component: AddEditCustomer },
  { path: `${routes.customers}/edit/:id`, exact: true, name: 'Edit Customer', component: AddEditCustomer },

  { path: `${routes.banners}`, exact: true, name: 'Banners', component: Banners },
  { path: `${routes.banners}/create`, exact: true, name: 'Add Banners', component: AddBanners },
  { path: `${routes.banners}/edit/:id`, exact: true, name: 'Edit Banners', component: AddBanners },

  { path: `${routes.reports}`, exact: true, name: 'Reports', component: Reports },

  { path: `${routes.quicklinks}`, exact: true, name: 'Quicklinks', component: Quicklinks },
  { path: `${routes.quicklinks}/create`, exact: true, name: 'Add Quicklinks', component: AddQuicklinks },
  { path: `${routes.quicklinks}/edit/:id`, exact: true, name: 'Edit Quicklinks', component: AddQuicklinks },

  { path: `${routes.employees}/create`, exact: true, name: 'Add Employee', component: AddEditEmployee },
  { path: `${routes.employees}/edit/:id`, exact: true, name: 'Edit Employee', component: AddEditEmployee },
  { path: `${routes.employees}/view/:id`, exact: true, name: 'View Employee', component: ViewEmployee },

  { path: `${routes.notification}`, exact: true, name: 'Notification', component: Notifications },
  { path: `${routes.notification}/create`, exact: true, name: 'Notification Add', component: AddNotification },
  { path: `${routes.notification}/edit/:id`, exact: true, name: 'Notification Edit', component: AddNotification },

  { path: `${routes.blogs}`, exact: true, name: 'Blogs', component: Blogs },
  { path: `${routes.blogs}/create`, exact: true, name: 'Blogs Add', component: AddBlogs },
  { path: `${routes.blogs}/edit/:id`, exact: true, name: 'Blogs Edit', component: AddBlogs },

  { path: `${routes.review}`, exact: true, name: 'Review', component: Reviews },
  { path: `${routes.review}/create`, exact: true, name: 'Review Add', component: AddReviews },
  { path: `${routes.review}/edit/:id`, exact: true, name: 'Review Edit', component: AddReviews },

];

export default PrivateRoutes;

